import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { useShallow } from 'zustand/shallow'
import { ImportSource } from '../enums'
import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  uploadingType: ImportSource | null
}

type Actions = {
  setUploadingType: (type: ImportSource | null) => void
  openUploadingType: (type: ImportSource) => void
  closeUploadingType: () => void
}

export const useImportsUploadingTypeStore = create<State & Actions>()(
  devtools(
    zustandPlugin((set) => ({
      uploadingType: null,
      setUploadingType: (uploadingType) =>
        set({ uploadingType }, false, 'setUploadingType'),
      openUploadingType: (type) =>
        set({ uploadingType: type }, false, 'openUploadingType'),
      closeUploadingType: () =>
        set({ uploadingType: null }, false, 'closeUploadingType'),
    }), 'imports-uploading-type'),
    { name: 'EasyTacho', store: 'imports-uploading-type' },
  ),
)

export const useImportsUploadingType = () =>
  useImportsUploadingTypeStore(
    useShallow((s) => ({
      uploadingType: s.uploadingType,
      setUploadingType: s.setUploadingType,
      openUploadingType: s.openUploadingType,
      closeUploadingType: s.closeUploadingType,
    })),
  )
